// src/components/roads/ponding/pondingApi.js
// Road ponding forecast + road terrain (TessaDEM) API — same apiFetch as the rest of the Road Works module.
import { apiFetch } from '../page/shared';

const qs = (o) => Object.entries(o).filter(([, v]) => v !== undefined && v !== null && v !== '' && v !== false)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v === true ? 1 : v)}`).join('&');

/** Network forecast. hourly=true includes each segment's hourly depth series (map playback). */
export const getPondingForecast = ({ force, minBand = 'watch', roadId, hourly = true, limit } = {}) =>
    apiFetch(`/roads/ponding-forecast?${qs({ force, min_band: minBand, road_id: roadId, hourly, limit })}`);

/** One road: segments + longitudinal ground profile with the peak water level. */
export const getRoadPonding = (roadId, { force } = {}) => apiFetch(`/roads/${encodeURIComponent(roadId)}/ponding?${qs({ force })}`);

export const getPondingHistory = (limit = 30) => apiFetch(`/roads/ponding-forecast/history?limit=${limit}`);

/** Slice the road if needed, then TessaDEM ground for the road + every segment (start / mid / end). */
export const refreshRoadElevation = (roadId) => apiFetch(`/elevation/roads/${encodeURIComponent(roadId)}/refresh`, { method: 'POST', body: JSON.stringify({}) });
